import Vue from 'vue';
import axios from 'axios';
import {SuccessModal} from './SuccessModal'
import {ErrorModal} from './ErrorModal';
import {API_URL} from '../utils/consts';

export default Vue.component('change-password-modal', {
    props: {
        translates: {},
        oldPassword: '',
        identifier: ''
    },

    data() {
        return {
            newPassword: '',
            newPassword2: '',
            msg: {},
            modalId: 'change-password-dialog'
        };
    },
    methods: {
        async changePassword() {
            const {newPassword} = this;
            if (!this.msg['newPassword'].length && !this.msg['newPassword2'].length) {
                try {
                    await axios.post(`${API_URL}/account/password/direct`, {identifier: this.identifier, oldPassword: this.oldPassword, password: newPassword}, {headers: {'content-type': 'application/json'}});
                    SuccessModal.show(this, 'Heslo bylo úspěšně změněno');
                    this.login()
                } catch (e) {
                    ErrorModal.show(this, this.$i18n.t(e.response.data['error'] ? `error.${e.response.data['error']}` : 'error.somethingWrong'))
                }
            }
        },
        validateNewPassword(value) {
            this.msg['newPassword'] = []
            if (value?.length < 12) {
                this.msg['newPassword'].push(this.translates['passwordMinLength'])
            }
            if (!/(?=.*[A-Z])/.test(value)) {
                this.msg['newPassword'].push(this.translates['passwordUpperCase'])
            }
            
            if (!/(?=.*[a-z])/.test(value)) {
                this.msg['newPassword'].push(this.translates['passwordLowerCase'])
            }
            if (!/(?=.*\d)/.test(value)) {
                this.msg['newPassword'].push(this.translates['passwordContainNumber'])
            }
            if (!/(?=.*\W)/.test(value)) {
                this.msg['newPassword'].push(this.translates['passwordSpecialCharacter'])
            }
        },
        validateNewPassword2(value) {
            if (this.newPassword === value) {
                this.msg['newPassword2'] = []
            } else {
                this.msg['newPassword2'] = [this.translates['passwordControlNotMatch']]
            }
        },
        close() {
            this.$modal.hide(this.modalId)
        },
        beforeOpen() {
            this.newPassword = ''
            this.newPassword2 = ''
            this.msg = {newPassword: [], newPassword2: []}
        },
        async login() {
            const payload = {
                'grant_type': 'client_credentials',
                'client_id': this.identifier,
                'client_secret': this.newPassword
            }
            try {
                const response = await axios.post(`${API_URL}/token`, payload, {headers: {'content-type': 'application/json'}})
                this.setAccessToken(response.data.access_token)
                window.location = '/contact/detail'
            } catch (e) {
                const {ErrorModal} = await import(/* webpackPrefetch: true */'../Modals/ErrorModal')
                ErrorModal.show(this, this.$i18n.t(e.response && e.response.data['errorr'] ? `error.${e.response.data['errorr']}` : 'error.somethingWrong'))
            }
        },
        setAccessToken(token) {
            if (token) {
                localStorage.setItem('accessToken', token)
            }
        },
    },
    watch: {
        newPassword(value) {
            this.newPassword = value;
            this.validateNewPassword(value);
        },
        newPassword2(value) {
            this.newPassword2 = value;
            this.validateNewPassword2(value);
        }
    }
});
